exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 768px) {\n.row {\n    display: flex !important;\n    flex-flow: column wrap !important;\n}\n.title_text {\n    font-size:75%;\n}\n.tool_bar {\n    height: 40;\n}\n}\n", ""]);

// exports
